import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserDao } from '@app/dao/user/user.dao';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { catchError, combineLatest, EMPTY, map, Observable, Subject, tap } from 'rxjs';
import {
  buildSimulationOwnerOptions,
  SimulationOwnerOption,
} from './simulation-owner-options';

@Component({
  selector: 'ea-simulation-owner-modal',
  templateUrl: './simulation-owner-modal.component.html',
  styleUrls: ['./simulation-owner-modal.component.scss'],
  standalone: false,
})
export class SimulationOwnerModalComponent implements OnInit, OnDestroy {
  readonly choice = new Subject<number[]>();
  options$: Observable<SimulationOwnerOption[]>;
  selected: SimulationOwnerOption;
  rememberedOwnerIds: number[];

  constructor(
    public modalRef: BsModalRef,
    private userDao: UserDao,
  ) {}

  ngOnInit() {
    this.options$ = combineLatest([
      this.userDao.getCouple(),
      this.userDao.getOwners(),
    ]).pipe(
      map(([couple, owners]) => buildSimulationOwnerOptions(couple, owners)),
      tap(options => (this.selected ??= this.initialOption(options))),
      catchError(() => {
        this.modalRef.hide();
        return EMPTY;
      }),
    );
  }

  private initialOption(options: SimulationOwnerOption[]): SimulationOwnerOption {
    const remembered = this.rememberedOwnerIds ?? [];
    return (
      options.find(
        option =>
          option.ownerIds.length === remembered.length &&
          option.ownerIds.every(ownerId => remembered.includes(ownerId)),
      ) ?? options[0]
    );
  }

  initialsOf(label: string): string {
    return label
      .split(' ')
      .filter(word => !!word)
      .slice(0, 2)
      .map(word => word[0].toUpperCase())
      .join('');
  }

  coupleMembers(
    couple: SimulationOwnerOption,
    options: SimulationOwnerOption[],
  ): SimulationOwnerOption[] {
    return options.filter(
      option =>
        option.kind === 'person' && couple.ownerIds.includes(option.ownerIds[0]),
    );
  }

  confirm() {
    this.choice.next(this.selected.ownerIds);
    this.modalRef.hide();
  }

  cancel() {
    this.modalRef.hide();
  }

  ngOnDestroy() {
    this.choice.complete();
  }
}
